import * as React from "react"
import { Link } from "gatsby"

const Layout = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath

  const header = (
    <h1 className="main-heading">
      <Link to="/">{title}</Link>
    </h1>
  )

  return (
    <div>
      <header className="global-header">
        {header}
        <div className="navigation">
          <div>
            <Link
              target="_blank"
              to="//www.figma.com/community/plugin/952719219374967553/Based-CDN"
            >
              <button className="cta-button">Try for Free</button>
            </Link>
          </div>
        </div>
      </header>
      <div className="global-wrapper" data-is-root-path={isRootPath}>
        <main>{children}</main>
      </div>
    </div>
  )
}

export default Layout
